import Lenis from 'lenis'

let instance: Lenis | null = null

export function getLenis() {
	return instance
}

export function setupLenis() {
	instance = new Lenis({
		autoRaf: true,
		lerp: 0.125,
		smoothWheel: true,
	})

	const raf = (time: number) => {
		instance?.raf(time)
		requestAnimationFrame(raf)
	}
	requestAnimationFrame(raf)
}
